import styled from 'styled-components';
import { styles } from '../constants/styles.js';
import { boxStyles } from '../Box/styles.js';
import { contentTextStyles } from '../ContentText/styles.web.js';
import { BoxPropsMapping } from '../Box/props.js';
import { generateTextLuminances } from '../utils/helpers/generateTextLuminances.js';
import { tinycolor } from '@ctrl/tinycolor';
import { visitedLighten, visitedDarken } from '../utils/helpers/style.js';

// these are excluded from underlying element rendered with styled-components
// HOX! Remember to add any new props to this list
var excludedLinkProps = ['noUnderline', 'theme'].concat(Object.keys(BoxPropsMapping));
var link = /*#__PURE__*/styled.a.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !excludedLinkProps.includes(prop);
  }
}).withConfig({
  displayName: "styles__link",
  componentId: "sc-1xoaj95-0"
})(["", " text-decoration:", ";color:", ";text-decoration-thickness:", ";&:focus,&:hover{color:", ";text-decoration-thickness:", ";}&:visited{color:", ";}transition:color ", ";transition-timing-function:", ";&:hover{cursor:pointer;text-decoration:underline;}", ""], contentTextStyles, function (props) {
  return props.noUnderline ? 'none' : 'underline';
}, function (props) {
  return generateTextLuminances('normal', props.theme)(props).bg;
}, function (props) {
  return props.theme.link.web.underlineThickness["default"];
}, function (props) {
  return generateTextLuminances('hover', props.theme)(props).bg;
}, function (props) {
  return props.theme.link.web.underlineThickness.hover;
}, function (props) {
  var bg = tinycolor(props.theme.colors.background);
  var color = tinycolor(props.color);
  return bg.isDark() ? color.lighten(visitedLighten).toHexString() : color.darken(visitedDarken).toHexString();
}, styles.transition.timing.base, styles.transition["function"].base, boxStyles);

export { excludedLinkProps, link };
